/*
  Boxxey Assistent — eigen chatwidget (2026-10-03). Geen externe chatapp, geen AI-API,
  geen netwerkverzoeken: alleen keuzeknoppen + herkenning van eenvoudige vragen met
  vaste, gecontroleerde antwoorden. Bij een onbekende vraag wordt niets verzonnen:
  de assistent zegt dat eerlijk en verwijst naar contact.

  Antwoorden aanpassen: zie ANSWERS hieronder (tekst = vaste zinnen, gebaseerd op de
  FAQ en productteksten op de site). Herkenning: zie INTENTS (trefwoorden).
  Markup en stijl: snippets/boxxey-assistent.liquid.
*/
(function () {
  'use strict';

  var root = document.getElementById('BoxxeyAssistent');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  var LINKS = {
    configurator: { label: 'Naar de configurator', href: '/#boxxey-configurator' },
    offerte: { label: 'Offerte aanvragen', href: '/pages/wijnkist-met-logo#offerte-formulier' },
    partner: { label: 'Partnerprijzen aanvragen', href: '/pages/wijnkist-met-logo?route=partner#offerte-formulier' },
    contact: { label: 'Contact opnemen', href: '/pages/contact' },
    zakelijk: { label: 'Bekijk de zakelijke pagina', href: '/pages/wijnkist-met-logo' }
  };

  var MAIN_CHOICES = [
    { label: 'Wat zit erin?', intent: 'inhoud' },
    { label: 'Wijn', intent: 'wijn' },
    { label: 'Personalisatie', intent: 'personalisatie' },
    { label: 'Zakelijk bestellen', intent: 'zakelijk' },
    { label: 'Verzending', intent: 'verzending' },
    { label: 'Contact', intent: 'contact' }
  ];

  // Vaste antwoorden. Alleen feiten die ook op de site staan.
  var ANSWERS = {
    inhoud: {
      text: ['In elke Boxxey zit:'],
      list: [
        'Een houten wijnkist, handgemaakt in Nederland',
        '3 soorten kruidenzaad: tijm, basilicum en peterselie',
        '3 bamboe potjes',
        'Kokostabletten, die met wat water uitgroeien tot potgrond',
        'Een handleiding'
      ],
      after: ['Een fles Italiaanse wijn is optioneel.'],
      actions: ['configurator'],
      choices: [{ label: 'Hoe werkt de kruidentuin?', intent: 'kruidentuin' }, { label: 'Welke wijnen?', intent: 'wijn' }]
    },
    kruidentuin: {
      text: [
        'Na het genieten van de wijn maak je de kist leeg. De kokostabletten groeien met wat water uit tot potgrond voor de bamboe potjes. Die zet je terug in de kist, en zo wordt hij een mini-kruidentuin met tijm, basilicum en peterselie.'
      ],
      actions: ['configurator'],
      choices: [{ label: 'Wat zit erin?', intent: 'inhoud' }]
    },
    wijn: {
      text: ['Je kiest uit vier Italiaanse wijnen, of voor een Boxxey zonder wijn:'],
      list: [
        "Totò Nero d'Avola BIO (rood)",
        'Primitivo (rood)',
        'Falanghina (wit)',
        'Viceré Inzolia BIO (wit)',
        'Zonder wijn, met dezelfde kist en kruiden'
      ],
      after: ['Wijn verkopen we alleen aan personen van 18 jaar en ouder.'],
      actions: ['configurator']
    },
    personalisatie: {
      text: [
        'Voor zakelijke bestellingen brengen we vanaf 10 stuks een logo, bedrijfsnaam of korte tekst aan op de voorkant van de kist. Dat loopt altijd via een offerte.',
        'Je logo upload je in het offerteformulier (PDF, AI, EPS, SVG, PNG of JPG). Een vectorbestand geeft het scherpste resultaat.'
      ],
      actions: ['offerte'],
      choices: [{ label: 'Hoe wordt het aangebracht?', intent: 'techniek' }]
    },
    techniek: {
      text: [
        'Dat hangt af van je logo en wensen: we branden het logo in het hout, of brengen het aan met zeefdruk (geschikt als je logo in kleur moet). We adviseren welke techniek het mooist uitpakt.'
      ],
      actions: ['offerte']
    },
    zakelijk: {
      text: [
        'Bestel je voor je eigen organisatie, voor medewerkers, klanten of relaties? Vraag dan een offerte aan. We stemmen aantal, wijnkeuze en eventuele personalisatie (vanaf 10 stuks) vooraf met je af.',
        'De prijs hangt af van het aantal, de wijnkeuze en de personalisatie. Na je aanvraag ontvang je binnen 1–2 werkdagen een voorstel op maat.'
      ],
      actions: ['offerte', 'zakelijk'],
      choices: [{ label: 'Ik wil Boxxey doorverkopen', intent: 'partner' }]
    },
    partner: {
      text: [
        'Ben je relatiegeschenkleverancier, webshop of wederverkoper? Dan werken we graag met je samen. Partnerprijzen zijn op aanvraag.'
      ],
      actions: ['partner']
    },
    prijs: {
      text: [
        'De actuele particuliere prijs zie je in de configurator, per wijn of zonder wijn.',
        'Voor bedrijven hangt de prijs af van het aantal, de wijnkeuze en de personalisatie; daarvoor maken we een offerte op maat.'
      ],
      actions: ['configurator', 'offerte']
    },
    verzending: {
      text: [
        'Bestellingen worden op werkdagen verwerkt en zijn binnen Nederland meestal binnen 2 tot 3 werkdagen bij je. Zodra je pakket onderweg is, ontvang je een Track & Trace-code.',
        'Particulier: gratis verzending vanaf €50. Zakelijk: de verzendkosten staan in de offerte.'
      ]
    },
    duurzaam: {
      text: [
        'De kisten worden in Nederland handgemaakt van PEFC-gecertificeerd hout. Onze productiepartner Drijvers werkt samen met sociale werkplaats Opmaat Brabant. Na het uitpakken krijgt de kist een tweede leven als kruidentuin.'
      ],
      actions: ['configurator']
    },
    contact: {
      text: ['Je kunt ons mailen via info@boxxey.nl of het contactformulier gebruiken. We reageren op werkdagen.'],
      actions: ['contact'],
      mail: true
    },
    groet: {
      text: ['Hoi! Kies hieronder een onderwerp, of typ je vraag.'],
      choices: MAIN_CHOICES
    },
    dank: {
      text: ['Graag gedaan! Kan ik nog ergens anders mee helpen?'],
      choices: MAIN_CHOICES
    },
    onbekend: {
      text: [
        'Daar heb ik helaas geen vast antwoord op, en ik wil je niets verkeerds vertellen. Stel je vraag via het contactformulier of mail naar info@boxxey.nl, dan helpen we je persoonlijk.'
      ],
      actions: ['contact'],
      mail: true,
      choices: MAIN_CHOICES
    }
  };

  // Herkenning: trefwoorden per onderwerp (op woordbegin, zonder accenten).
  var INTENTS = [
    { id: 'kruidentuin', words: ['kruidentuin', 'kweek', 'kweken', 'zaai', 'zaaien', 'groei', 'groeien', 'water geven', 'hoe werkt de kist', 'planten', 'potgrond'], weight: 3 },
    { id: 'inhoud', words: ['inhoud', 'zit erin', 'zit er in', 'wat krijg', 'pakket', 'kruiden', 'kruid', 'zaad', 'zaden', 'zaadje', 'tijm', 'basilicum', 'peterselie', 'potje', 'potjes', 'bamboe', 'kokos', 'handleiding', 'wat zit'] },
    { id: 'wijn', words: ['wijn', 'wijnen', 'rood', 'rode', 'wit', 'witte', 'primitivo', 'falanghina', 'toto', 'nero', 'vicere', 'inzolia', 'alcohol', 'alcoholvrij', 'zonder wijn', 'fles', 'vegan', 'biologisch', 'bio', '18', 'leeftijd'] },
    { id: 'techniek', words: ['branden', 'gebrand', 'inbranden', 'ingebrand', 'zeefdruk', 'graveren', 'graveer', 'gegraveerd', 'gravure', 'laser', 'gelaserd', 'geprint', 'printen', 'aangebracht', 'aanbrengen', 'techniek'], weight: 2 },
    { id: 'personalisatie', words: ['logo', 'tekst', 'naam', 'bedrijfsnaam', 'personalis', 'persoonlijk', 'opdruk', 'bedrukk', 'bedrukt', 'eigen ontwerp', 'vectorbestand', 'upload'], weight: 1.5 },
    { id: 'partner', words: ['doorverkop', 'wederverkop', 'reseller', 'partner', 'webshop', 'relatiegeschenkleverancier', 'groothandel', 'inkoop'], weight: 2 },
    { id: 'zakelijk', words: ['zakelijk', 'bedrijf', 'bedrijven', 'organisatie', 'offerte', 'relatiegeschenk', 'medewerker', 'personeel', 'klanten', 'relaties', 'stuks', 'aantal', 'bulk', 'grote bestelling'] },
    { id: 'prijs', words: ['prijs', 'prijzen', 'kost', 'kosten', 'euro', 'tarief', 'hoe duur'] },
    { id: 'verzending', words: ['verzend', 'verzending', 'verzendkosten', 'levering', 'leveren', 'levertijd', 'bezorg', 'bezorging', 'opsturen', 'track', 'wanneer in huis', 'in huis', 'hoe snel', 'hoe lang', 'werkdagen', 'wanneer ontvang', 'ontvang ik', 'wanneer krijg', 'bestelling er', 'bezorgd', 'geleverd', 'verstuurd'] },
    { id: 'duurzaam', words: ['duurzaam', 'duurzaamheid', 'sociaal', 'opmaat', 'pefc', 'drijvers', 'hout', 'milieu', 'werkplaats'] },
    { id: 'contact', words: ['contact', 'mail', 'email', 'e-mail', 'bellen', 'telefoon', 'medewerker spreken', 'mens', 'vraag stellen', 'bereiken', 'bereikbaar', 'spreken'] },
    // Onderwerpen waar bewust GEEN vast antwoord voor is: altijd eerlijk 'onbekend' + contact,
    // in plaats van een half passend antwoord (bijv. houdbaarheid, retour, Kerst-deadline, betalen).
    { id: 'onbekend', words: ['houdbaar', 'houdbaarheid', 'hoe lang blijven', 'hoe lang blijft', 'blijven goed', 'blijft goed', 'retour', 'retourneren', 'terugsturen', 'ruilen', 'kerst', 'betalen', 'betaling', 'paypal', 'ideal', 'klarna', 'korting', 'kortingscode'], weight: 5 },
    { id: 'dank', words: ['bedankt', 'dankje', 'dank je', 'dankjewel', 'thanks', 'top', 'super'], weight: 0.5 },
    { id: 'groet', words: ['hoi', 'hallo', 'hey', 'goedemorgen', 'goedemiddag', 'goedenavond', 'hi'], weight: 0.5 }
  ];

  function normalize(s) {
    return (' ' + String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9€]+/g, ' ') + ' ').replace(/\s+/g, ' ');
  }

  function recognise(question) {
    var q = normalize(question);
    var scores = {};
    INTENTS.forEach(function (intent) {
      var w = intent.weight || 1;
      intent.words.forEach(function (word) {
        var k = normalize(word).trim();
        if (!k) return;
        if (q.indexOf(' ' + k) !== -1) scores[intent.id] = (scores[intent.id] || 0) + w;
      });
    });
    var ranked = Object.keys(scores).sort(function (a, b) { return scores[b] - scores[a]; });
    // Alleen beleefdheid (hoi/bedankt) telt niet mee als er ook een echt onderwerp is.
    var topical = ranked.filter(function (id) { return id !== 'groet' && id !== 'dank'; });
    if (topical.length) {
      if (topical.length > 1 && scores[topical[0]] === scores[topical[1]]) return { ambiguous: topical.slice(0, 3) };
      return { intent: topical[0] };
    }
    if (ranked.length) return { intent: ranked[0] };
    return { intent: 'onbekend' };
  }

  // ---------- UI ----------
  var launcher = root.querySelector('[data-ba-launcher]');
  var panel = root.querySelector('[data-ba-panel]');
  var log = root.querySelector('[data-ba-log]');
  var form = root.querySelector('[data-ba-form]');
  var input = root.querySelector('[data-ba-input]');
  var closeBtn = root.querySelector('[data-ba-close]');
  var STORE_KEY = 'boxxeyAssistentLog';
  var history = [];
  var started = false;

  function save() {
    try { sessionStorage.setItem(STORE_KEY, JSON.stringify(history.slice(-30))); } catch (e) {}
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function scrollLog() {
    log.scrollTop = log.scrollHeight;
  }

  function renderUser(text) {
    var row = el('div', 'ba-msg ba-msg--user');
    row.appendChild(el('p', 'ba-bubble', text));
    log.appendChild(row);
  }

  function renderBot(key, extraChoices) {
    var a = ANSWERS[key] || ANSWERS.onbekend;
    var row = el('div', 'ba-msg ba-msg--bot');
    var bubble = el('div', 'ba-bubble');
    (a.text || []).forEach(function (t) { bubble.appendChild(el('p', null, t)); });
    if (a.list) {
      var ul = el('ul');
      a.list.forEach(function (t) { ul.appendChild(el('li', null, t)); });
      bubble.appendChild(ul);
    }
    (a.after || []).forEach(function (t) { bubble.appendChild(el('p', null, t)); });
    if (a.mail) {
      var p = el('p');
      var m = el('a', 'ba-inline-link', 'info@boxxey.nl');
      m.href = 'mailto:info@boxxey.nl';
      p.appendChild(document.createTextNode('E-mail: '));
      p.appendChild(m);
      bubble.appendChild(p);
    }
    row.appendChild(bubble);
    if (a.actions && a.actions.length) {
      var acts = el('div', 'ba-actions');
      a.actions.forEach(function (id) {
        var l = LINKS[id];
        if (!l) return;
        var link = el('a', 'ba-action', l.label);
        link.href = l.href;
        link.setAttribute('data-ba-link', '');
        acts.appendChild(link);
      });
      row.appendChild(acts);
    }
    var choices = extraChoices || a.choices;
    if (choices && choices.length) row.appendChild(renderChoices(choices));
    log.appendChild(row);
  }

  function renderChoices(choices) {
    var wrap = el('div', 'ba-choices');
    choices.forEach(function (c) {
      var b = el('button', 'ba-choice', c.label);
      b.type = 'button';
      b.setAttribute('data-intent', c.intent);
      wrap.appendChild(b);
    });
    return wrap;
  }

  function renderAmbiguous(ids) {
    var names = { inhoud: 'Wat zit erin?', kruidentuin: 'Hoe werkt de kruidentuin?', wijn: 'Wijn', personalisatie: 'Personalisatie', techniek: 'Hoe wordt het logo aangebracht?', zakelijk: 'Zakelijk bestellen', partner: 'Doorverkopen', prijs: 'Prijs', verzending: 'Verzending', duurzaam: 'Duurzaamheid', contact: 'Contact' };
    var row = el('div', 'ba-msg ba-msg--bot');
    var bubble = el('div', 'ba-bubble');
    bubble.appendChild(el('p', null, 'Ik weet niet zeker wat je bedoelt. Gaat je vraag over een van deze onderwerpen?'));
    row.appendChild(bubble);
    row.appendChild(renderChoices(ids.map(function (id) { return { label: names[id] || id, intent: id }; })));
    log.appendChild(row);
  }

  function replay() {
    history.forEach(function (h) {
      if (h.u) renderUser(h.u);
      else if (h.amb) renderAmbiguous(h.amb);
      else renderBot(h.b);
    });
  }

  function greet() {
    var row = el('div', 'ba-msg ba-msg--bot');
    var bubble = el('div', 'ba-bubble');
    bubble.appendChild(el('p', null, 'Hoi! Waarmee kan ik je helpen?'));
    row.appendChild(bubble);
    row.appendChild(renderChoices(MAIN_CHOICES));
    log.appendChild(row);
  }

  function answer(key) {
    renderBot(key);
    history.push({ b: key });
    save();
    scrollLog();
  }

  function ask(text) {
    var t = String(text || '').trim().slice(0, 200);
    if (!t) return;
    renderUser(t);
    history.push({ u: t });
    var r = recognise(t);
    if (r.ambiguous) {
      renderAmbiguous(r.ambiguous);
      history.push({ amb: r.ambiguous });
      save();
      scrollLog();
      return;
    }
    answer(r.intent);
  }

  function start() {
    if (started) return;
    started = true;
    greet();
    try { history = JSON.parse(sessionStorage.getItem(STORE_KEY) || '[]') || []; } catch (e) { history = []; }
    if (!Array.isArray(history)) history = [];
    replay();
    scrollLog();
  }

  // 2026-10-03 (2): venster binnen het zichtbare scherm houden, ook als het
  // toetsenbord open is (mobiel). Het toetsenbord verkleint de "visual viewport";
  // het venster schuift dan omhoog en wordt hooguit zo hoog als wat zichtbaar is.
  function syncViewport() {
    var vv = window.visualViewport;
    if (!vv || !root.classList.contains('is-open')) {
      root.style.removeProperty('--ba-kb');
      root.style.removeProperty('--ba-vh');
      return;
    }
    var kb = Math.max(0, Math.round(window.innerHeight - vv.height - vv.offsetTop));
    root.style.setProperty('--ba-kb', kb + 'px');
    root.style.setProperty('--ba-vh', Math.round(vv.height) + 'px');
    scrollLog();
  }
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', syncViewport);
    window.visualViewport.addEventListener('scroll', syncViewport);
  }
  input.addEventListener('focus', function () { setTimeout(syncViewport, 350); });

  function open() {
    start();
    root.classList.add('is-open');
    syncViewport();
    panel.hidden = false;
    launcher.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(function () {
      scrollLog();
      // Op touchscreens niet automatisch het toetsenbord openen.
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) input.focus({ preventScroll: true });
      else closeBtn.focus({ preventScroll: true });
    });
  }

  function close(returnFocus) {
    root.classList.remove('is-open');
    syncViewport();
    panel.hidden = true;
    launcher.setAttribute('aria-expanded', 'false');
    if (returnFocus) launcher.focus({ preventScroll: true });
  }

  launcher.addEventListener('click', function () {
    if (root.classList.contains('is-open')) close(true);
    else open();
  });
  closeBtn.addEventListener('click', function () { close(true); });
  root.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) { e.stopPropagation(); close(true); }
  });

  log.addEventListener('click', function (e) {
    var c = e.target.closest('[data-intent]');
    if (c) {
      renderUser(c.textContent);
      history.push({ u: c.textContent });
      answer(c.getAttribute('data-intent'));
      return;
    }
    var link = e.target.closest('[data-ba-link]');
    if (!link) return;
    // Doel op déze pagina: venster sluiten en erheen scrollen.
    var url = new URL(link.href, window.location.href);
    if (url.pathname === window.location.pathname && url.hash && !url.search) {
      var target = document.getElementById(url.hash.slice(1));
      if (target) {
        e.preventDefault();
        close(false);
        target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        if (window.history.replaceState) window.history.replaceState(null, '', url.hash);
      }
    }
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    ask(input.value);
    input.value = '';
  });

  // ---------- Niet over belangrijke bediening heen (vooral mobiel) ----------
  // De startknop verdwijnt zolang een belangrijke knop/link in de onderste zone van
  // het scherm staat, een menu/winkelmand open is, of de cookiemelding zichtbaar is.
  var AVOID = [
    '.configurator-boxxey__ctas',
    '.configurator-boxxey__age-check',
    '.configurator-boxxey__login-gate .button',
    '#QuoteBoxxeyForm [type="submit"]',
    '.quote-boxxey__submit',
    '.cart__ctas',
    '.cart__checkout-button',
    '.boxxey-footer__legal',
    '.boxxey-footer__base',
    '.boxxey-footer__bottom'
  ].join(',');
  var inZone = new Set();

  function blocked() {
    if (root.classList.contains('is-open')) return false;
    if (document.body.className.indexOf('overflow-hidden') !== -1) return true;
    var cookie = document.getElementById('shopify-pc__banner');
    if (cookie && cookie.offsetParent !== null && getComputedStyle(cookie).visibility !== 'hidden') return true;
    var drawer = document.querySelector('cart-drawer.active, cart-notification .active, .cart-notification.active');
    if (drawer) return true;
    return inZone.size > 0;
  }

  function updateLauncher() {
    root.classList.toggle('is-tucked', blocked());
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) inZone.add(en.target);
        else inZone.delete(en.target);
      });
      updateLauncher();
    }, { rootMargin: '-72% 0px 0px 0px' });
    var observed = new Set();
    var observeAll = function () {
      document.querySelectorAll(AVOID).forEach(function (n) {
        if (!root.contains(n) && !observed.has(n)) { observed.add(n); io.observe(n); }
      });
    };
    observeAll();
    window.addEventListener('load', observeAll);
    setTimeout(observeAll, 2500);
  }
  if ('MutationObserver' in window) {
    new MutationObserver(updateLauncher).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }
  setInterval(updateLauncher, 1500);
  updateLauncher();

  // Testhaak (headless tests); geen invloed op bezoekers.
  root.__recognise = recognise;
  root.__syncViewport = syncViewport;
})();
